// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#000000","menuActiveText":"#409eff","subMenuActiveText":"#000000","menuBg":"#e7e7ee","menuHover":"#263445","subMenuBg":"#f4f4f5","subMenuHover":"#001528","sideBarWidth":"210px"};
    if(module.hot) {
      // 1732068084609
      var cssReload = require("D:/project/huixin/云商/V12_saas版/erp-flexible-web21-cloud-saas/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  